import { createClient } from '@supabase/supabase-js';

// Configured via .env.local (gitignored). Null when not set so importing
// this before env vars are configured (e.g. a fresh checkout) is harmless.
const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = (url && key)
  ? createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true } })
  : null;
